import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { Tooltip } from '@material-ui/core'
import BrandedDocument from '../../../../molecules/BrandedDocument'
import DenaliLogo from '../../../../../apps/aiApp/Assistant/common/DenaliLogo'
import Icon from '../../../../atoms/Icon'
import { usePolicy } from '../../../../../hooks/usePolicy'
import { getIconUrl, isIconPadded } from './catalogIcons'

// Add global style for catalog badge positioning (only once)
if (typeof document !== 'undefined' && !document.getElementById('catalog-badge-styles')) {
  const style = document.createElement('style')
  style.id = 'catalog-badge-styles'
  style.textContent = `
    .catalog-datasource-link .flex.absolute {
      top: 8px !important;
      right: 8px !important;
    }
  `
  document.head.appendChild(style)
}

function DatasourceLink ({ datasource }) {
  const isInternalUser = usePolicy('admin_denali_internal')

  const badges = useMemo(() => {
    const result = []
    if (isInternalUser && datasource.isSystem) {
      result.push((
        <div key='system'>
          <Tooltip title='System'>
            <div className='px-1 bg-neutral-050 radius-sm' style={{ border: 'var(--border-neutral-thin)' }}>
              <Icon customSize='20px' name='storage' style={{ fill: 'var(--color-neutral-600)' }} />
            </div>
          </Tooltip>
        </div>
      ))
    }
    if (isInternalUser && datasource.isInternal) {
      result.push((
        <div key='internal'>
          <Tooltip title='Internal'>
            <div className='px-1 bg-neutral-050 radius-sm' style={{ border: 'var(--border-neutral-thin)' }}>
              <Icon customSize='20px' name='lock' style={{ fill: 'var(--color-neutral-600)' }} />
            </div>
          </Tooltip>
        </div>
      ))
    }
    if (datasource.isAiEnabled) {
      result.push((
        <div key='denali_logo_ai_enabled'>
          <Tooltip title='AI-Enabled'>
            <div className='px-1 bg-neutral-050 radius-sm' style={{ border: 'var(--border-neutral-thin)' }}>
              <DenaliLogo size='20px' />
            </div>
          </Tooltip>
        </div>
      ))
    }
    if (datasource.isAlwaysAvailable) {
      result.push((
        <div key='always_available'>
          <Tooltip title='Always Available'>
            <div className='px-1 bg-neutral-050 radius-sm' style={{ border: 'var(--border-neutral-thin)' }}>
              <Icon customSize='20px' name='pin' style={{ fill: 'var(--color-info-500)' }} />
            </div>
          </Tooltip>
        </div>
      ))
    }
    if (datasource.isDeprecated) {
      result.push((
        <div key='denali_logo_deprecated'>
          <Tooltip title='Deprecated'>
            <div className='px-1 bg-neutral-050 radius-sm' style={{ border: 'var(--border-neutral-thin)' }}>
              <Icon customSize='20px' name='delete' style={{ fill: 'var(--color-warning-500)' }} />
            </div>
          </Tooltip>
        </div>
      ))
    }

    return result
  }, [datasource, isInternalUser])

  return (
    <Link to={`/admin/denali/catalog/s/${datasource.catalogDatasourceId}`} key={datasource.code} className='catalog-datasource-link'>
      <BrandedDocument
        name={datasource.displayName}
        imageUrl={getIconUrl(datasource)}
        imagePadded={isIconPadded(datasource)}
        badges={badges}
      />
    </Link>
  )
}

DatasourceLink.propTypes = {
  datasource: PropTypes.shape({
    type: PropTypes.string,
    catalogDatasourceId: PropTypes.number,
    code: PropTypes.string,
    displayName: PropTypes.string,
    imageUrl: PropTypes.string,
    isAiEnabled: PropTypes.bool,
    isDeprecated: PropTypes.bool,
    isSystem: PropTypes.bool,
    isInternal: PropTypes.bool,
    isAlwaysAvailable: PropTypes.bool,
    namespace: PropTypes.shape({
      displayName: PropTypes.string
    })
  })
}

export default DatasourceLink
